import ApiService from '@/services/api.service'


const MessageTemplateSetupsService = {
    getAll( parameter) { 
         
      const requestData = {
        method: 'get',
        url: "/MessageTemplateSetups",
        headers: {
        },
        params: { 
          SearchCriteria: parameter.SearchCriteria,
          PageSize: parameter.PageSize,          
          PageNumber : parameter.PageNumber,
          NotificationType : parameter.NotificationType,
          SendTo : parameter.SendTo,
          ShowIn : parameter.ShowIn
        }
      }     
      return ApiService.customRequest(requestData);         
    },

    CreateNotificationMessage(parameter) {
      var param = {};
      var _Url = '/MessageTemplateSetups/CreateNotificationMessage';
      param.MessageType = parameter.MessageType;
      param.NotificationType = parameter.NotificationType;   
      param.EntityCode = parameter.EntityCode
      const requestData = {
        method: 'get',
        url: _Url,
        params: param
      }
      return ApiService.customRequest(requestData);
    },
}
  
  export default MessageTemplateSetupsService;